import type { HudCopyDictionary, HudCopyKey } from './keys';
import neutralDictionary from './neutral.json';
import focDictionary from './foc.json';
import childrenDictionary from './children.json';
import swarmDictionary from './swarm.json';

export type FactionId = 'neutral' | 'foc' | 'children' | 'swarm';

export interface HudCopyProfile {
  factionId: FactionId;
  factionLabel: string;
  dictionary: HudCopyDictionary;
}

export const DEFAULT_PLAYER_FACTION_ID: FactionId = 'foc';

export const HUD_COPY_PROFILES: Record<FactionId, HudCopyProfile> = {
  neutral: {
    factionId: 'neutral',
    factionLabel: 'Neutral',
    dictionary: neutralDictionary,
  },
  foc: {
    factionId: 'foc',
    factionLabel: 'ФОК',
    dictionary: focDictionary,
  },
  children: {
    factionId: 'children',
    factionLabel: 'Дети Плода',
    dictionary: childrenDictionary,
  },
  swarm: {
    factionId: 'swarm',
    factionLabel: 'Рой',
    dictionary: swarmDictionary,
  },
};

export function resolveHudCopyProfile(
  factionId: FactionId = DEFAULT_PLAYER_FACTION_ID,
): HudCopyProfile {
  return HUD_COPY_PROFILES[factionId];
}

export function hudCopy(profile: HudCopyProfile, key: HudCopyKey): string {
  return profile.dictionary[key];
}
